import { Icon } from './Icon';

export type MarkKind = 'improvised' | 'adapted' | 'generated' | 'trial' | 'fallback' | 'promoted';

const M: Record<MarkKind, { label: string; icon: string; color: string; soft: string }> = {
  improvised: {
    label: 'IMPROVVISATA',
    icon: 'wand-sparkles',
    color: 'var(--violet)',
    soft: 'var(--violet-soft)',
  },
  adapted: { label: 'ADATTATA', icon: 'route', color: 'var(--info)', soft: 'var(--info-soft)' },
  generated: {
    label: 'RUOLO GENERATO',
    icon: 'sparkles',
    color: 'var(--violet)',
    soft: 'var(--violet-soft)',
  },
  trial: {
    label: 'IN PROVA',
    icon: 'flask-conical',
    color: 'var(--warn)',
    soft: 'var(--warn-soft)',
  },
  fallback: {
    label: 'RIPIEGO',
    icon: 'refresh-ccw',
    color: 'var(--warn)',
    soft: 'var(--warn-soft)',
  },
  promoted: { label: 'PROMOSSO', icon: 'star', color: 'var(--ok)', soft: 'var(--ok-soft)' },
};

// Il marchio SEMPRE porta una motivazione: senza `reason` non si disegna (§4.3).
export function OriginMark({ kind, reason }: { kind: MarkKind; reason: string }) {
  if (!reason) return null;
  const m = M[kind];
  return (
    <span
      title={reason}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        height: 18,
        padding: '0 8px',
        borderRadius: 'var(--r-full)',
        background: m.soft,
        color: m.color,
        font: '600 11px/14px var(--font-ui)',
        letterSpacing: '0.08em',
        whiteSpace: 'nowrap',
      }}
    >
      <Icon name={m.icon} size={12} />
      {m.label}
    </span>
  );
}
